module.exports = __webpack_public_path__ + "img/icon_dianpu_WXGYS.157fc2b8.png";